import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      width: '90%',
      height: '31px',
      border: '1px dashed grey',
      borderRadius: '10px',
      backgroundColor: '#F5F5F5',
      margin: '4px',
      padding: '5px 0px 5px 15px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      color: '#6F6F6F',
      cursor: 'pointer',
    },
    highlight: {
      border: '1px solid #F37320',
      color: 'black',
      fontWeight: 'bold',
    },
  }),
  { index: 1 },
)

export { useStyles }
